import { PayloadAction } from "@reduxjs/toolkit";
import { Error } from "../../../../utl/models/Error";
import { UserState } from "../models/UserState";

const setErrorNameVendor = (state: UserState, action: PayloadAction<Error>) => {
    state.vendor.vendorNameError = action.payload.error;
}

export default setErrorNameVendor;